import React from "react";
import { PageNavbar } from "../components";

const CheckoutPage = () => {
  return (
    <>
      <PageNavbar />
      <main className="checkoutPage">
        <div className="pageHero">
          <h1 className="pageHero__text">Checkout</h1>
        </div>
        <section className="checkout">
          <h2>Page under construction</h2>
        </section>
      </main>
    </>
  );
};

export default CheckoutPage;
